module.exports = __webpack_public_path__ + "static/media/EN-BANZEMA_Landing_page.e8b4fcb9.webp";